import { __awaiter, __generator } from "tslib";
import { writable } from 'svelte/store';
export var isPlaying = writable(false);
export var index = writable(-1);
export var indexOps = { increment: function () { return index.update(function (n) { return n + 1; }); }, reset: function () { return index.set(-1); } };
var wakeLock = null;
var requestWakeLock = function () { return __awaiter(void 0, void 0, void 0, function () {
    var err_1;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                _a.trys.push([0, 2, , 3]);
                return [4 /*yield*/, navigator.wakeLock.request('screen')];
            case 1:
                wakeLock = _a.sent();
                return [3 /*break*/, 3];
            case 2:
                err_1 = _a.sent();
                console.log(err_1);
                return [3 /*break*/, 3];
            case 3: return [2 /*return*/];
        }
    });
}); };
isPlaying.subscribe(function (playing) {
    if (playing) {
        requestWakeLock();
    }
    else {
        if (wakeLock) {
            wakeLock.release()
                .then(function () {
                wakeLock = null;
            });
        }
    }
});
